module.exports = __webpack_public_path__ + "static/media/andreaBiondi.cd60f136.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/andreaBiondi.jpg
// module id = 1556
// module chunks = 1